import React from "react";
import { Input, InputProps } from "reactstrap";
import { useTranslation } from "react-i18next";
import { CategoryTypeEnum } from "../../enums";

type TProps = InputProps & {
  placeholder: string;
};

export const CategoriesTypeSelect: React.FC<TProps> = ({
  placeholder,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <div className="input-group">
      <Input type="select" {...props}>
        {/* Placeholder */}
        <option value="">{t(placeholder)}</option>

        {/* Enum options */}
        {Object.values(CategoryTypeEnum).map((value) => (
          <option key={value} value={value} className="text-capitalize">
            {t(`categoryType.${value}`)}
          </option>
        ))}
      </Input>
    </div>
  );
};
